import React from "react";

function ClockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
    >
      <g clip-path="url(#clip0_1848_3386)">
        <path
          d="M11.6094 6C11.6094 7.29293 11.0958 8.53291 10.1815 9.44715C9.26728 10.3614 8.02731 10.875 6.73438 10.875C5.44144 10.875 4.20147 10.3614 3.28723 9.44715C2.37299 8.53291 1.85938 7.29293 1.85938 6C1.85938 4.70707 2.37299 3.46709 3.28723 2.55285C4.20147 1.63861 5.44144 1.125 6.73438 1.125C8.02731 1.125 9.26728 1.63861 10.1815 2.55285C11.0958 3.46709 11.6094 4.70707 11.6094 6ZM0.734375 6C0.734375 7.5913 1.36652 9.11742 2.49173 10.2426C3.61695 11.3679 5.14308 12 6.73438 12C8.32567 12 9.8518 11.3679 10.977 10.2426C12.1022 9.11742 12.7344 7.5913 12.7344 6C12.7344 4.4087 12.1022 2.88258 10.977 1.75736C9.8518 0.632141 8.32567 0 6.73438 0C5.14308 0 3.61695 0.632141 2.49173 1.75736C1.36652 2.88258 0.734375 4.4087 0.734375 6ZM6.17188 2.8125V6C6.17188 6.1875 6.26562 6.36328 6.42266 6.46875L8.67266 7.96875C8.93047 8.14219 9.27969 8.07187 9.45312 7.81172C9.62656 7.55156 9.55625 7.20469 9.29609 7.03125L7.29688 5.7V2.8125C7.29688 2.50078 7.04609 2.25 6.73438 2.25C6.42266 2.25 6.17188 2.50078 6.17188 2.8125Z"
          fill="#6B7280"
        />
      </g>
      <defs>
        <clipPath id="clip0_1848_3386">
          <path d="M0.734375 0H12.7344V12H0.734375V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ClockIcon;
